import { Button } from "@cvpartner/design-system";
import {
  MessageTextSquare02,
  RefreshCcw01,
} from "@cvpartner/design-system/icons/line";
import * as Sentry from "@sentry/react";
import * as React from "react";
import { useRouteError } from "react-router";
import { getCvPartner } from "@/util/getCvPartner.ts";
import { I18n } from "@/util/translations.ts";
import { OldBrowser } from "./OldBrowser.tsx";
import lookoutMan from "./lookout-man.svg";
import { errorIcon } from "./styles.css.ts";
import { Wrapper } from "./wrapper.tsx";

const Error: React.FC = () => (
  <Wrapper
    heading={I18n.t("unexpected_application_error")}
    description={I18n.t("error_messages.refresh")}
    buttons={
      <>
        <div>
          <Button
            leadingIcon={RefreshCcw01}
            onPress={() => {
              window.location.reload();
            }}
          >
            {I18n.t("button.refresh_page")}
          </Button>
        </div>
        <div>
          <Button
            hierarchy="secondaryColor"
            leadingIcon={MessageTextSquare02}
            onPress={() => {
              window.Intercom("showNewMessage", "Hi!");
            }}
          >
            {I18n.t("signin.link_contact_support")}
          </Button>
        </div>
      </>
    }
    icon={<img className={errorIcon} src={lookoutMan} aria-hidden={true} />}
    iconPosition="below"
  />
);

const isOldBrowser = typeof Array.prototype.toSorted !== "function";

export const RouteError: React.FC = () => {
  const error = useRouteError();

  React.useEffect(() => {
    if (error != null && typeof error === "object") {
      getCvPartner().faro?.api.pushError(error as Error);

      if (isOldBrowser) {
        Sentry.withScope((scope) => {
          scope.setLevel("warning");
          scope.setExtra("isOldBrowser", isOldBrowser);

          scope.captureException(error);
        });
      } else {
        Sentry.captureException(error);
      }
    }
  }, [error]);

  if (isOldBrowser) {
    return <OldBrowser />;
  }

  return <Error />;
};
